import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function MenuIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="4"
        height="16"
        viewBox="0 0 4 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2 0C3.105 0 4 0.895 4 2C4 3.105 3.105 4 2 4C0.895 4 0 3.105 0 2C0 0.895 0.895 0 2 0Z" />
        <path d="M2 6C3.105 6 4 6.895 4 8C4 9.105 3.105 10 2 10C0.895 10 0 9.105 0 8C0 6.895 0.895 6 2 6Z" />
        <path d="M4 14C4 12.895 3.105 12 2 12C0.895 12 0 12.895 0 14C0 15.105 0.895 16 2 16C3.105 16 4 15.105 4 14Z" />
      </svg>
    </Icon>
  );
}
